import {combineReducers} from 'redux'
import ecafDetails from './ecafDetails'
import saHelp from './saHelp'
import personalDetails from './personalDetails'
import courses from './courses'

export default combineReducers({
  ecafDetails,
  saHelp,
  personalDetails,
  courses
})
